import { Bookmark, PlusCircle } from "react-feather";
import { Nav, NavItem } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Href, NewBookmark, Tags, Views } from "../../../../Constants/Constants";
import { BookmarkSideData, BookmarkTagData } from "../../../../Data/Applications/Bookmark/Bookmark";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setAddModal, setTagModal, updateActiveTabs } from "../../../../ReduxToolkit/Reducers/BookmarkTabSlice";
import BookmarkModal from "./ModalBookMark";
import ModalTag from "./ModalTag";

const NavTab = () => {
  const { activeTabs, bookMarkList } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const onHandleClick = (id: string) => dispatch(updateActiveTabs(id));

  return (
    <Nav className="main-menu" role="tablist">
      <NavItem>
        <Btn color="primary" className="badge-primary btn-block w-100 btn-mail" onClick={() => dispatch(setAddModal())}>
          <Bookmark className="me-2" />{NewBookmark}<BookmarkModal />
        </Btn>
      </NavItem>
      <NavItem><span className="main-title f-w-700">{Views}</span></NavItem>
      {BookmarkSideData.map((data, index) => (
        <NavItem key={index}>
          <a className={`${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} href={Href}>
            <span className="title">{data.title} {data.title === "Favorites" && `(${bookMarkList.length})`}</span>
          </a>
        </NavItem>
      ))}
      <NavItem><hr /></NavItem>
      <NavItem>
        <span className="main-title f-w-700">
          {Tags}
          <span className="pull-right" onClick={() => dispatch(setTagModal())}>
            <a href={Href}><PlusCircle /></a>
          </span>
        </span>
      </NavItem>
      <ModalTag />
      {BookmarkTagData.map((data, index) => (
        <NavItem key={index}>
          <a className={`${activeTabs === data.value ? "active" : ""}`} onClick={() => onHandleClick(data.value)} href={Href}>
            <span className="title"> {data.title}</span>
          </a>
        </NavItem>
      ))}
    </Nav>
  );
};

export default NavTab;
